import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import styles from "./gallery.module.css";


const Gallery = ({ video, images }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => {
    setModalOpen(true);
    setSelectedImage(image);
  };

  return (
    <div className={styles.galleryContainer}>
      <video 
       className={styles.video} 
       src={video} 
       controls
       autoPlay = {true}
        />
      <div className={styles.imgContainer}>
        {images.map((image, index) => (
          <img
            src={image}
            key={index}
            onClick={() => handleImageClick(image)}
            alt={`Gallery image ${index}`}
            className={styles.galleryimg}
          />
        ))}
      </div>
      {modalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            background: "rgba(0, 0, 0, 0.5)",
          }}
        >
          <img
            src={selectedImage}
            alt="Selected Image"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              margin: "auto",
              position: "absolute",
              top: "0",
              left: "0",
              bottom: "0",
              right: "0",
            }}
          />
          <button
            onClick={() => setModalOpen(false)}
            style={{ position: "absolute", top: "10px", right: "10px" }}
          >
            <img className={styles.closeImg} src="https://img.icons8.com/ios/50/000000/multiply.png" alt="close" />
          </button>
        </div>
      )}
    </div>
  );
};

export default Gallery;
